module.exports = __webpack_public_path__ + "static/media/img_Inscription_kotobuki@2x.5bdf78be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@2x/img_Inscription_kotobuki@2x.png
// module id = 973
// module chunks = 0